import { Routes } from '@angular/router';
import { FIELDS_BASE_PATHS } from '../../base-paths';

export const FIELD_TYPES_ADMIN_ROUTING: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/field-types-admin-table/field-types-admin-table.component').then(
        (m) => m.FieldTypesAdminTableComponent,
      ),
  },
  {
    path: '**',
    redirectTo: `/${FIELDS_BASE_PATHS.FIELD_TYPES}`,
    pathMatch: 'full',
  },
];
